import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from "js-cookie"

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        sxArr: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'],
        sexArr: [['female', '女'], ['male', '男']],
        sxYear: [
            ['2020', '2008', '1996', '1984', '1972', '1960'],
            ['2009', '1997', '1985', '1973', '1961', '1949'],
            ['2010', '1998', '1986', '1974', '1962', '1950'],
            ['2011', '1999', '1987', '1975', '1963', '1951'],
            ['2012', '2000', '1988', '1976', '1964', '1952'],
            ['2013', '2001', '1989', '1977', '1965', '1953'],
            ['2014', '2002', '1990', '1978', '1966', '1954'],
            ['2015', '2003', '1991', '1979', '1967', '1955'],
            ['2016', '2004', '1992', '1980', '1968', '1956'],
            ['2017', '2005', '1993', '1981', '1969', '1957'],
            ['2018', '2006', '1994', '1982', '1970', '1958'],
            ['2019', '2007', '1995', '1983', '1971', '1959'],
        ],
        //生肖共用数据-待删
        datas: null,
        //生肖运程数据
        sxdata: null,
        sellid: null,
    },
    mutations: {
        //设置生肖数据
        setDatas(state, data) {
            state.datas = data
        },
        //设置销售ID
        setSellid(state, sellid) {
            if (sellid) {
                Cookie.set("sellid", sellid)
            }else{
                sellid = Cookie.get("sellid")
            }
            if (sellid){
                state.sellid = sellid
            }
        }
    },
    getters: {
        //生肖对象
        sxObj(state) {
            let imgs = []
            state.sxArr.forEach((sxt, i) => {
                imgs.push({
                    sxt,
                    img: require('./assets/img/sx_' + i + '.png')
                })
            })
            return imgs;
        },
        //视频封面
        vdoImg(state) {
            let imgs = [[], []]
            state.sxArr.forEach((sxt, i) => {
                imgs[0].push(require('./assets/img/female/vdo_' + i + '.jpg'))
                imgs[1].push(require('./assets/img/male/vdo_' + i + '.jpg'))
            })
            return imgs
        }
    }
})

export default store